/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Methods that can be called on the hub
 * @export
 * @interface DeviceHubInputMethods
 */
export interface DeviceHubInputMethods {
    /**
     * Invoke it via `signalRHub.("joinGroup", groupName)
     * groupName: either device_<deviceId> to subscribe to a device, or TODO...
     * @type {string}
     * @memberof DeviceHubInputMethods
     */
    joinGroup?: string;
    /**
     * Invoke it via `signalRHub.("leaveGroup", groupName)
     *
     * @type {string}
     * @memberof DeviceHubInputMethods
     */
    leaveGroup?: string;
}

/**
 * Check if a given object implements the DeviceHubInputMethods interface.
 */
export function instanceOfDeviceHubInputMethods(
    value: object,
): value is DeviceHubInputMethods {
    return true;
}

export function DeviceHubInputMethodsFromJSON(
    json: any,
): DeviceHubInputMethods {
    return DeviceHubInputMethodsFromJSONTyped(json, false);
}

export function DeviceHubInputMethodsFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceHubInputMethods {
    if (json == null) {
        return json;
    }
    return {
        joinGroup: json["joinGroup"] == null ? undefined : json["joinGroup"],
        leaveGroup: json["leaveGroup"] == null ? undefined : json["leaveGroup"],
    };
}

export function DeviceHubInputMethodsToJSON(
    value?: DeviceHubInputMethods | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        joinGroup: value["joinGroup"],
        leaveGroup: value["leaveGroup"],
    };
}
